export default {
  PLACEHOLDER_SELECT_ADDRESS: 'Selecteer een adres',
  INVOICES_MY_INVOICES: 'Mijn facturen',
  INVOICES_INVOICES_PURCHASE_HISTORY: 'Mijn bestellingen / Bestelgeschiedenis',
  INVOICES_NO_INVOICES_FOUND: 'Er zijn geen facturen gevonden.',
  INVOICES_ORDER_NUMBER: 'Ordernummer',
  INVOICES_INVOICE_DATE: 'Factuurdatum',
  INVOICES_PAYMENT_METHOD: 'Betaalmethode',
  INVOICES_PRICES: 'Prijs',
  INVOICES_DOWNLOAD: 'Download',
  INVOICES_PER_PAGE: '/ pagina',
  PAYMENT_METHOD_CREDIT_CARD: 'Creditcard',
  PAYMENT_METHOD_ADVANCED_PAYMENT: 'Bankoverschrijving',
  CHECKOUT_DELIVER_TO: 'Bezorgen aan:',
  CHECKOUT_BILLING_TO: 'Facturatie aan:',
  CHECKOUT_SAMPLE_COPIES_ADDRESS: 'Verzendadres voor etiketstalen',
  CARD_ITEM_BUTTON_SAMPLE_COPIES: 'Etiketstalen',
  CUSTOMER_SERVICE_TITLE: 'Klantenservice',
  CUSTOMER_SERVICE_CONTACT: 'Contact',
  CUSTOMER_SERVICE_AVAILABLE_FROM: 'Beschikbaar vanaf',
  CUSTOMER_SERVICE_AVAILABLE_UNTIL: 'Beschikbaar tot',
  CHANGE_PW_TITLE: 'Je wachtwoord moet worden gewijzigd.',
  CHANGE_PW_CHANGE: 'Gegevens bijwerken',
  CHANGE_PW_CURRENT_PW: 'Huidig wachtwoord*',
  CHANGE_PW_NEW_PW: 'Nieuw wachtwoord*',
  CHANGE_PW_REPEAT_PW: 'Herhaal nieuw wachtwoord*',
  CHANGE_PW_EMAIL_MISMATCH: 'Het e-mailadres komt niet overeen met de momenteel ingelogde gebruiker.',

  ASSERT_FIELD_REQUIRED: 'Dit is verplicht',
  ASSERT_MINIMUM_LENGTH: 'Minimaal aantal tekens:',
  ASSERT_MAXIMUM_LENGTH: 'Maximaal aantal tekens:',
  ASSERT_BOTH_FIELDS_MUST_BE_EQUAL: 'Beide velden moeten overeenkomen.',
  ASSERT_INVALID_EMAIL: 'Vul een geldig e-mailadres in.',
  ASSERT_INVALID_PASSWORD:
    'Uw wachtwoord moet minimaal 8 tekens lang zijn en minstens één hoofdletter, één kleine letter, één cijfer en één speciaal teken bevatten.',

  AWS_COGNITO_ERROR_ATTEMPT_LIMIT: 'U heeft het te vaak geprobeerd. Probeer het later opnieuw.',
  AWS_COGNITO_ERROR_USER_NOT_CONFIRMED:
    'Uw account is nog niet bevestigd. Klik op de link in de bevestigingsmail die we u hebben gestuurd.',
  AWS_COGNITO_ERROR_PASSWORD_RESET_REQUIRED: 'U moet uw wachtwoord opnieuw instellen voordat u kunt inloggen.',
  AWS_COGNITO_ERROR_NETWORK:
    'We konden geen verbinding maken met de inlogservice. Probeer het over enkele ogenblikken opnieuw.',
  AWS_COGNITO_ERROR_TOO_MANY_REQUESTS:
    'Onze service is momenteel erg druk. Probeer het over enkele ogenblikken opnieuw.',
  AWS_COGNITO_ERROR_LIMIT_EXCEEDED:
    'Er zijn te veel verzoeken voor dit account ingediend. Wacht een paar minuten voordat u het opnieuw probeert.',
  AWS_COGNITO_ERROR_SESSION_EXPIRED: 'Uw sessie is verlopen. Log opnieuw in met uw tijdelijke wachtwoord.',

  LOGIN_EMAIL: 'E-mailadres*',
  LOGIN_PASSWORD: 'Wachtwoord*',
  LOGIN_LOGIN: 'Inloggen',
  LOGIN_FORGOT_PASSWORD: 'Wachtwoord opnieuw instellen',

  FORGOT_PASSWORD_CODE_SENT: 'Als dit e-mailadres bij ons bekend is, ontvangt u binnenkort een herstelcode.',
  FORGOT_PASSWORD_INVALID_CODE: 'Invalid verification code provided, please try again.',
  FORGOT_PASSWORD_SEND_CODE: 'Herstelcode versturen',
  FORGOT_PASSWORD_EMAIL: 'E-mailadres*',
  FORGOT_PASSWORD_RESET_CODE: 'Herstelcode*',
  FORGOT_PASSWORD_NEW_PASSWORD: 'Nieuw wachtwoord*',
  FORGOT_PASSWORD_REPEAT_NEW_PASSWORD: 'Herhaal nieuw wachtwoord*',
  FORGOT_PASSWORD_BACK_TO_LOGIN: 'Terug naar inloggen',
  FORGOT_PASSWORD_RESET_PASSWORD: 'Wachtwoord opnieuw instellen',
  FORGOT_PASSWORD_CODE_RESENT: 'Als dit e-mailadres bij ons bekend is, ontvangt u binnenkort een herstelcode.',
  FORGOT_PASSWORD_HINTS_TITLE: 'Geen e-mail ontvangen?',
  FORGOT_PASSWORD_HINT_SPAM: 'Controleer uw spamfolder.',
  FORGOT_PASSWORD_HINT_EMAIL: 'Controleer of u het juiste e-mailadres heeft ingevuld',
  FORGOT_PASSWORD_CHANGE_EMAIL: 'E-mailadres wijzigen',
  FORGOT_PASSWORD_HINT_RESEND: 'Herstelcode opnieuw versturen',
  LOGIN_RESEND_CONFIRMATION: 'Bevestigingsmail opnieuw versturen',
  LOGIN_RESEND_CONFIRMATION_SUCCESS: 'Er is een nieuwe bevestigingsmail verstuurd.',
  LOGIN_RESEND_CONFIRMATION_ERROR: 'We konden de bevestigingsmail niet versturen. Probeer het later opnieuw.',
  SHOW_PASSWORD: 'Wachtwoord tonen',
  HIDE_PASSWORD: 'Wachtwoord verbergen',

  MODAL_OK: 'OK',
  MODAL_CANCEL: 'Annuleren',
  MODAL_DUPLICATE_FILE_TITLE: 'Dubbele bestanden geüpload',
  MODAL_DUPLICATE_FILE_DESCRIPTION: 'Het volgende bestand is al geüpload:',

  PLUS_MATERIAL_HINT: 'Geschikt voor onderdompeling in een ijsemmer',
  LOADING_DATA_ISSUE_JOB: 'Een ogenblik geduld terwijl we uw taakconfiguraties ophalen...',
  SHOW_UNIT_COUNT: 'Aantal eenheden tonen',
  LOT: 'LOT (Optioneel)',
  LINE_1: 'regel 1',
  LINE_2: 'regel 2',
  LINE_3: 'regel 3',
  LINE_4: 'regel 4',
  PROOFING_SERVICE: 'Proefdrukservice',

  ORDER_TEMPLATES_TITLE: 'Bestelsjablonen',
  ORDER_TEMPLATES_SELECT: 'Geselecteerde bestelsjabloon',
  ORDER_TEMPLATES_SELECT_PLACEHOLDER: 'Selecteer een bestelsjabloon.',
  ORDER_TEMPLATES_NO_TEMPLATES: 'Er zijn geen bestelsjablonen beschikbaar.',

  PRODUCTION_TYPE_STANDARD: 'Standard',
  PRODUCTION_TYPE_EXPRESS: '48 uur Express',
  PRODUCTION_TYPE_SUPER_EXPRESS: '24 uur Super Express',
  PRODUCTION_TYPE_ESTIMATED_SHIPPING_DATE: 'Verwachte verzenddatum',
  PRODUCTION_TYPE_SHIPPING_DATE: 'Verzenddatum',
  PRODUCTION_TYPE_NOT_POSSIBLE: 'Niet mogelijk',

  SHOW_PRICE_IN_CURRENCY: 'Prijs weergeven in {currency}',
  CURRENCY_SWITCH_DISABLED_CART_NOT_EMPTY: 'De valuta kan niet worden gewijzigd zolang je winkelwagen artikelen bevat.',
  CART_MIXED_CURRENCY_WARNING:
    "Je winkelwagen bevat artikelen in verschillende valuta's. Verwijder de artikelen in een andere valuta voordat je afrekent.",
  CHECKOUT_USER_DISABLED:
    'Met je account kunnen geen bestellingen worden geplaatst. Neem contact op met onze klantenservice.',
  DESIGN_SERVICE_CURRENCY_DISABLED: 'Design Service kan alleen in {currency} worden besteld.',
  PACKAGE_ORDER_CURRENCY_DISABLED: 'Dit pakket kan alleen in {currency} worden besteld.',
  CHANGE_CURRENCY_CALCULATOR: 'Wijzig eerst de valuta in de calculator op de homepage.',

  CART_ITEM_DISCOUNT_NOT_APPLICABLE: 'Voor dit artikel wordt vanwege speciale prijzen geen klantkorting toegekend.',
  UPLOAD_SORTS_CONFIG_NOT_SAVED:
    'Je soortenconfiguratie kon niet worden opgeslagen. Controleer of de aantallen van alle soorten samen het totale aantal vormen en probeer het opnieuw.',
  HPI_WHITE: 'Dekwit',
  YES: 'Ja',
  NO: 'Nee',

  UPS_STANDARD_SHIPPING: 'UPS Standard',
  UPS_EXPRESS_SHIPPING: 'UPS Express Saver',
  UPS_STANDARD_SHIPPING_NEUTRAL: 'UPS Standard – CO₂-compensatie',
  UPS_EXPRESS_SHIPPING_NEUTRAL: 'UPS Express Saver – CO₂-compensatie'
} as const
